import React from 'react'

const WeddingParty = () => {
  return (
    <div>Wedding Party</div>
  )
}

export default WeddingParty